const STORAGE_SECRET = 'TESTTESTTESTTESTTESTTESTTESTTEST';
export default STORAGE_SECRET;